(function($){
  
  jQuery(document).ready(function(){
    $('.main-menu nav ul li.child').hover(
      function(e){
        $(this).children('ul').addClass('visible');
      },
      function(e){
        $(this).children('ul').removeClass('visible');
      }
    );
    
    
  });

})(jQuery);